import { UserProvider } from './contexts/userProvider';
import { BrowserRouter } from 'react-router-dom';
import Alert from './components/Alert';
import Routeror from './routes/Routeror';

function App() {
  
  return (
    <div className="w-full min-h-screen m-0 p-0 font-sans bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300 overflow-x-hidden">
      <BrowserRouter>
        <UserProvider>
          <Alert />
          <Routeror />
        </UserProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
